import { i18n } from '@js/i18n'
import { documentTypes } from '@const'

export default {
  form: {
    docs: {
      [documentTypes.kycMemorandium]: null,
      [documentTypes.kycSignatoriesAuthorization]: null,
      [documentTypes.kycOrganizationChart]: null
    }
  },
  requiredDocs: [documentTypes.kycProofOfAddress,
    documentTypes.kycSignatoriesAuthorization,
    documentTypes.kycOrganizationChart],
  rows: [
    [
      {
        "heading": i18n.lbl_upload_docs()
      }
    ],
    [
      {
        "name": "kyc-memorandium",
        "id":  "kyc-memorandium",
        "subheading": i18n.kyc_upload_memorandium(),
        "field": "file",
        "side": "front",
        "fileType": "image",
        "required": true,
        "type": documentTypes.kycMemorandium,
        "validate": "required"
      }
    ],
    [
      {
        "name": "kyc-singatories-authorization",
        "id":  "kyc-singatories-authorization",
        "subheading": i18n.kyc_upload_signatories(),
        "field": "file",
        "side": "front",
        "fileType": "image",
        "required": true,
        "type": documentTypes.kycSignatoriesAuthorization,
        "validate": "required"
      }
    ],    [
      {
        "name": "kyc-organization-chart",
        "id":  "kyc-organization-chart",
        "subheading": i18n.kyc_upload_chart(),
        "field": "file",
        "side": "front",
        "required": true,
        "type": documentTypes.kycOrganizationChart,
        "validate": "required"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/syndicate/step-7.documents.schema.js